import {useMutation, useQueryClient} from "@tanstack/react-query";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";
import {toast} from "react-toastify";
import {IFileCreate} from "../../types/knowledgeBase.types";

interface UploadFileParams {
    folderId: string;
    data: IFileCreate;
}

export function useUploadKBFile() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.UPLOAD_FILE],
        mutationFn: ({ folderId, data }: UploadFileParams) => 
            KnowledgeBaseAPI.uploadFile(folderId, data),

        onError() {
            toast.error("Ошибка при загрузке файла");
        },

        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_FILES]});
            toast.success("Файл успешно загружен");
        }
    });
}